import { Box as RadixBox } from '@radix-ui/themes'
import { forwardRef } from 'react'
import type { ComponentPropsWithoutRef } from 'react'

type BoxProps = ComponentPropsWithoutRef<typeof RadixBox>

export const Box = forwardRef<HTMLDivElement, BoxProps>(
  ({ className = '', ...props }, ref) => {
    return <RadixBox className={className} ref={ref} {...props} />
  }
)

Box.displayName = 'Box'
